import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUser from '../_reducers/user';

export const selectUserState = createFeatureSelector<fromUser.UserState>('users');

export const selectAllUsers = createSelector(selectUserState, fromUser.selectAll);
